import React from 'react'
import {
  BundleCartItem,
  Maybe,
  CustomizableEngraveOption,
} from '_app/graphql/generated/graphql'
import { CartItem } from 'modules/cart/types'
import { EngravingOptions } from './EngravingOptions'

export type CustomizableEngraveCartItem =
  | Maybe<CartItem>
  | (Maybe<BundleCartItem> & {
      product?: {
        options: Maybe<CustomizableEngraveOption>[];
      };
    });

interface PaidOptionsProps {
  cartItem: CustomizableEngraveCartItem;
  isShowEngravingTitle?: boolean;
  isDrawerMode?: boolean;
}

export const PaidOptions = ({
  cartItem,
  isShowEngravingTitle = true,
  isDrawerMode = false,
}: PaidOptionsProps) => {
  const paidOptions = cartItem?.customizable_options || []

  if (!cartItem?.product?.options) {
    return null
  }

  return (
    <EngravingOptions
      cartItem={cartItem}
      options={paidOptions}
      customizableEngravingOptions={cartItem.product.options}
      isShowEngravingTitle={isShowEngravingTitle}
      isDrawerMode={isDrawerMode}
    />
  )
}
